import { theme } from '../../../styles/theme';
import {
  ButtonLoadingContainer,
  InputLoadingContainer,
  InputLoadingText,
  ButtonLoadingText,
  SpinningIcon,
} from './LlmPromptUI';

interface IProps {
  buttonQueryTypeDisplay: string;
  promptQueryTypeDisplay: string;
}

const LlmPromptLoading = ({
  buttonQueryTypeDisplay,
  promptQueryTypeDisplay,
}: IProps) => {
  return (
    <>
      <InputLoadingContainer>
        <InputLoadingText>
          AI is generating {promptQueryTypeDisplay} ...
        </InputLoadingText>
      </InputLoadingContainer>
      <ButtonLoadingContainer>
        <ButtonLoadingText>Building {buttonQueryTypeDisplay}</ButtonLoadingText>
        <SpinningIcon
          name="ai-loading"
          width={18}
          height={18}
          customFill={theme.colors.white}
        />
      </ButtonLoadingContainer>
    </>
  );
};

export default LlmPromptLoading;
